module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/enquiry_accepted-8ee54608c0614004b1208722b35f36e0.png";